<script>
import Filter, { IS } from '@/plugins/sdk/Filter'
import TradingAccounts from '@/components/Application/Sales/ToDo/TradingAccounts'
import PastDue from '@/components/Application/Sales/ToDo/Opportunities/PastDue'
import Upcoming from '@/components/Application/Sales/ToDo/Opportunities/Upcoming'
import LaterOn from '@/components/Application/Sales/ToDo/Opportunities/LaterOn'
import InTheFuture from '@/components/Application/Sales/ToDo/Opportunities/InTheFuture'
import Completed from '@/components/Application/Sales/ToDo/Opportunities/Completed'

export default {
  components: {
    PastDue,
    Upcoming,
    LaterOn,
    InTheFuture,
    Completed
  },
  extends: TradingAccounts,
  data () {
    return {
      filters: [
        new Filter('account.status', IS, [ 'lead', 'pending' ], true, true)
      ]
    }
  }
}
</script>
